import settings from "../utils/settings";
import SFError from "../models/SfError";
const useVoidTransaction = () => {
  const voidTransaction = async ({
    transactionNo,
    pin,
    memberId,
    version,
    remark,
  }) => {
    const { realmId, branchId, token } = settings();
    try {
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/payment/void`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            locale: "en-US",
            transaction_no: transactionNo,
            authorize_pin: String(pin),
            member_id: memberId,
            realm_id: realmId,
            branch_id: branchId,
            remark: remark,
            reason: remark,
            __v: version,
          }),
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return error.json();
      }
      const jsonResult = await result.json();
      return jsonResult;
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return sfError.json();
    }
  };
  return { voidTransaction };
};

export default useVoidTransaction;
